<template>
  <SoDialog v-model="value" :max-width="600" card-title="Appointment Details">
    <p class="mb-2">
      <span class="font-weight-medium">Appointment Reference Number: </span>
      {{ booking.displayJobNumber }}
    </p>

    <p class="mb-2">
      <span class="font-weight-medium">Appointment Date: </span>
      {{ booking.dateFormatted }}
    </p>

    <p class="mb-2">
      <span class="font-weight-medium">Time: </span>
      {{ booking.timeSlotFormatted }}
    </p>

    <p class="mb-2">
      <span class="font-weight-medium">Appointment Status: </span>
      <SoStatus :status="booking.status" />
    </p>

    <p class="font-weight-medium">Customer Details</p>
    <div class="d-flex">
      <div class="mr-4">
        <p>{{ booking.customerName }}</p>
        <p>{{ booking.customerEmail }}</p>
        <p>{{ booking.customerPhone }}</p>
      </div>
      <div>
        <p>{{ booking.address }}</p>
        <p>{{ booking.postcode }}</p>
      </div>
    </div>

    <p class="font-weight-medium mt-2">Job type</p>
    <div v-if="booking.electricityMeterSerialNumber">
      <p>Meter {{ booking.electricityMeterSerialNumber }}</p>
      <p>
        {{ bookingJobDetails }}
      </p>
    </div>
    <div v-if="booking.gasMeterSerialNumber">
      <p>Meter {{ booking.gasMeterSerialNumber }}</p>
      <p>
        {{ bookingJobDetails }}
      </p>
    </div>

    <p class="font-weight-medium mt-2">Medical Equipment</p>
    <p>{{ booking.medicalEquipment ? "Yes" : "No" }}</p>

    <div v-if="booking.eligibleForCancellation" class="mt-4">
      <SoButton title="Cancel Appointment" @click="showCancelDialog = true" />
    </div>
    <SoAlert v-else class="mt-4" type="info">
      This appointment is not eligible to be changed.
    </SoAlert>
  </SoDialog>

  <CancelAppointmentDialog v-model="showCancelDialog" :booking="booking" />
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import CancelAppointmentDialog from "./CancelAppointmentDialog.vue"
  import { IImbpBooking } from "@/models/imbpBooking/imbpBooking.types"

  export default defineComponent({
    components: {
      SoDialog,
      SoStatus,
      SoButton,
      SoAlert,
      CancelAppointmentDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      booking: {
        type: Object as PropType<IImbpBooking>,
        required: true,
      },
      bookingJobDetails: {
        type: String,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        showCancelDialog: false,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>
